var map = {
	"./Payment/card.png": 2076,
	"./Payment/card_inside.png": 6117,
	"./Payment/slot.png": 5678,
	"./UPSlogo.png": 52,
	"./additional_orders.png": 8238,
	"./adidas/bacode_scan.png": 3918,
	"./adidas/blank.png": 8824,
	"./adidas/blank_border.png": 3283,
	"./adidas/locker_adidas.png": 9829,
	"./arrow-back.png": 238,
	"./arrow-down.png": 2235,
	"./arrow-up.png": 9720,
	"./background.png": 3495,
	"./background_old.png": 5549,
	"./barcode_rectangle.png": 2125,
	"./barcode_rounded.png": 9817,
	"./bg-services-menu.png": 9945,
	"./bg.png": 1386,
	"./card.png": 4697,
	"./clean_box_logo.png": 7478,
	"./close-envelope.png": 1726,
	"./deliveryservice.png": 2562,
	"./dry cleaning_OLD.png": 2921,
	"./edit.png": 3943,
	"./en_flag.png": 8425,
	"./epost_logo.png": 9780,
	"./epost_small_logo.png": 6748,
	"./error-i.png": 4211,
	"./exelot_barcode.png": 7671,
	"./exelot_barcode_fail.png": 6952,
	"./exelot_barcode_manual.png": 2758,
	"./exelot_barcode_manual_icon.png": 3312,
	"./exelot_locker.png": 3719,
	"./exelot_logo.png": 7726,
	"./exelot_logo_menu.png": 7174,
	"./exelot_ray_manual.png": 8382,
	"./exelot_shein_logo.png": 8464,
	"./eye.png": 9988,
	"./fashion.png": 4311,
	"./he_flag.png": 1709,
	"./ironing and package_OLD.png": 8496,
	"./ironing_OLD.png": 8579,
	"./jefBasket.png": 5306,
	"./jefNrml.png": 2315,
	"./jefRope.png": 4908,
	"./jefThanks.png": 3491,
	"./landryservice.png": 3998,
	"./laundry ironing package_OLD.png": 4708,
	"./laundry ironing_OLD.png": 592,
	"./laundry_OLD.png": 9478,
	"./locker.png": 6527,
	"./mail.png": 5046,
	"./map/location_map_icon.png": 610,
	"./map/location_map_icon_active.png": 6497,
	"./mini_lock.png": 9030,
	"./mini_lock2.png": 3382,
	"./mini_phone.png": 7351,
	"./mini_phone2.png": 9589,
	"./name.png": 6282,
	"./one_project_logo_white.png": 2529,
	"./oneproject_logo.png": 2044,
	"./oneproject_small_logo.png": 2996,
	"./orange_locker.png": 3366,
	"./orange_locker_done_login.png": 3341,
	"./phone_icon.png": 3407,
	"./qrcode_dhl.png": 9324,
	"./rent.png": 6874,
	"./rent_locker.png": 723,
	"./returnpackage.png": 6833,
	"./returnsExternal.png": 2799,
	"./ru_flag.png": 711,
	"./shopping-bag.png": 7378,
	"./suite_case.png": 4996,
	"./touch_station.png": 3095,
	"./trash_can.png": 5154,
	"./trash_can_sign.png": 9500,
	"./you_got_it_done.png": 4482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;